(() => {
  const init=root=>root.querySelectorAll?.('[data-s7-specs]').forEach(section=>{
    if(section.dataset.ready)return;section.dataset.ready='1';
    const tabs=[...section.querySelectorAll('[data-spec-tab]')],panels=[...section.querySelectorAll('[data-spec-panel]')];
    tabs.forEach(btn=>btn.addEventListener('click',()=>{tabs.forEach(b=>b.classList.toggle('is-active',b===btn));panels.forEach(p=>p.classList.toggle('is-active',p.dataset.specPanel===btn.dataset.specTab));}));
  });
  if (window.__ISWS7Specs) {
    window.__ISWS7Specs.init(document);
    return;
  }

  window.__ISWS7Specs = { init };

  const boot = () => window.__ISWS7Specs.init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Motion lifecycle event: theme assets are fully ready.
  document.addEventListener('page:loaded', boot);

  // Shopify Theme Editor section reload.
  document.addEventListener('shopify:section:load', e => {
    window.__ISWS7Specs.init(e.target);
  });
})();